{
  "workflow_step_and_status": {
    "CREATING": "Creating",
    "FIRST_VALIDATION": "First validation",
    "SECOND_VALIDATION": "Second validation",
    "TO_EDIT": "To modify",
    "VALIDATING": "Being validated",
    "CONTRACT_MANAGEMENT": "In submission & management",
    "EVENT_IN_PROGRESS": "Event in progress",
    "EVENT_VALIDATING": "Expenses validation",
    "EVENT_IS_FINISHED": "Event is finished",
    "CANCELED": "Canceled"
  },
  "deposit_status": {
    "CREATING": "To send",
    "PENDING": "Pending",
    "DONE": "Done",
    "FAILED": "Failed",
    "SUBMISSION_INCOMPLETE": "Submission incomplete",
    "VALIDATION_PENDING": "Validation pending",
    "CONVENTION_AUTHORIZED": "Convention authorized",
    "CONVENTION_REFUSED": "Convention refused",
    "CANCELED": "Canceled",
    "RECOMMENDATION_PENDING": "Recommendation pending",
    "SUBMISSION_SENT": "Submission sent",
    "WAITING_FOR_NOTIFICATION": "Waiting for notification of a complete deposit"
  },
  "notification_ticket_roles_to_notify": {
    "INITIATOR": "Initiator",
    "VALIDATOR_1": "Validator 1",
    "VALIDATOR_2": "Validator 2",
    "MANAGER_CRM": "Manager CRM",
    "APPROVER_CRM": "Approver CRM"
  }
}
